// src/components/common/AvailabilityToggle.jsx
import { useState } from 'react';
import api from '../../lib/api';
import { success, error } from '../../components/common/Toast';

const AvailabilityToggle = ({ profileId, isActive: initialActive, onToggle }) => {
  const [isActive, setIsActive] = useState(initialActive);
  const [loading, setLoading] = useState(false);

  const handleToggle = async () => {
    if (loading) return;
    setLoading(true);

    try {
      await api.put(`/profile/${profileId}`, { status: !isActive });
      setIsActive(!isActive);
      success(`You are now ${!isActive ? 'ACTIVE' : 'INACTIVE'}`);
      if (onToggle) onToggle();
    } catch (err) {
      error('Failed to update');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleToggle}
      disabled={loading}
      className={`
        relative inline-flex items-center h-11 w-52 rounded-full font-bold text-white transition-all duration-300
        ${loading ? 'opacity-70 cursor-wait' : 'hover:shadow-xl'}
        ${isActive 
          ? 'bg-gradient-to-r from-green-500 to-emerald-600' 
          : 'bg-gradient-to-r from-gray-400 to-gray-600'
        }
      `}
    >
      {/* Text */}
      <span className="relative z-10 px-8 text-lg">
        {loading ? 'Updating...' : (isActive ? 'AVAILABLE' : 'NOT AVAILABLE')}
      </span>

      {/* Sliding Circle */}
      <div
        className={`
          absolute top-1.5 w-10 h-10 bg-white rounded-full shadow-lg transition-all duration-300
          ${isActive ? 'translate-x-36' : 'translate-x-1.5'}
        `}
      />
    </button>
  );
};

export default AvailabilityToggle;